import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
    Container,
    Typography,
    TextField,
    Table, TableBody, TableRow, TableCell, MenuItem,
} from '@mui/material';
import { GetCookieInfo } from '../../../logic/CookieManager';
import {
    Black,
    StyledButtonOrange,
    StyledButtonContainer,
    StyledTableCell
} from "../../../styles/MyStyles";
import {GetClientViewName} from "../../../logic/ClientNameHelper";
import {GetEnumMenuItems} from "../../../logic/EnumHelper";
import {GetClients} from "../../../logic/DataProvider";

const LimitEditPage = () => {
    const { clientId, memberId} = useParams();
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});

    const [companyMember, setCompanyMember] = useState({
        companyId: clientId,
        type: '',
        memberId: '',
        sharesInPercent: null
    });
    const [clients, setClients] = useState([]);

    useEffect(() => {
        const fetchCompanyMember = async () => {
            try {
                const tokenCookie = GetCookieInfo('nplt');
                if (memberId) {
                    const response = await fetch(
                        `${process.env.REACT_APP_COMPANY_MEMBERS_URL}/single/${memberId}`,
                        {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: 'Bearer ' + tokenCookie.value,
                            },
                        }
                    );
                    if (response.ok) {
                        const data = await response.json();
                        setCompanyMember(data.data);
                    } else {
                        console.log('Fetch company member failed.');
                    }
                } else {
                    setCompanyMember({
                        companyId: clientId,
                        type: '',
                        memberId: '',
                        sharesInPercent: null
                    });
                    console.log(companyMember);
                }
            } catch (error) {
                console.log('An error occurred:', error);
            }
        };
        GetClients().then((clients) => setClients(clients));
        fetchCompanyMember();
    }, [memberId]);

    const validateForm = () => {
        let newErrors = {};

        if (companyMember.type === '') {
            newErrors.type = 'Type is required.';
        }

        if (companyMember.memberId === '') {
            newErrors.memberId = 'Member is required.';
        }

        return newErrors;
    };

    const handleFieldChange = (event) => {
        setCompanyMember({
            ...companyMember,
            [event.target.name]: event.target.value,
        });

        //setErrors(validateForm());
    };

    const handleSave = async () => {
        try {
            const newErrors = validateForm();

            if (Object.keys(newErrors).length > 0) {
                setErrors(newErrors);
                return;
            }

            if (companyMember.sharesInPercent == '') {
                companyMember.sharesInPercent = null;
            }

            const tokenCookie = GetCookieInfo('nplt');
            const response = await fetch(
                `${process.env.REACT_APP_COMPANY_MEMBERS_URL}`,
                {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                    body: JSON.stringify(companyMember),
                }
            );
            if (response.ok) {
                console.log('Company member updated successfully.');
                handleGoBack();
            } else {
                console.log('Update company member failed.');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const handleGoBack = () => {
        navigate(-1);
    };

    const getClientsMenuItems = () => {
        let items = [];
        if (clients) {
            clients.forEach((elem) => {
                items.push(
                    <MenuItem key={elem.id} value={elem.id}>
                        {GetClientViewName(elem)}
                    </MenuItem>
                );
            });
        }
        return items;
    }

    return (
        <Container sx={{ margin: '0.2rem', minWidth: '99%' }}>
            <Typography variant="h4" gutterBottom sx={{ color: Black }}>
                {memberId ? 'Edit Company Member' : 'Create Company Member'}
            </Typography>
            <StyledButtonContainer container>
                <StyledButtonOrange variant="contained" onClick={handleGoBack}>
                    Back
                </StyledButtonOrange>
                <StyledButtonOrange variant="contained" onClick={handleSave}>
                    Save
                </StyledButtonOrange>
            </StyledButtonContainer>
            <Table>
                <TableBody>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Type</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="type"
                                label="Type"
                                select
                                value={companyMember.type}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.type}
                                helperText={errors.type}
                            >
                                {GetEnumMenuItems('companyMemberType')}
                            </TextField>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Member</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="memberId"
                                label="Member"
                                select
                                value={companyMember.memberId}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.memberId}
                                helperText={errors.memberId}
                            >
                                {getClientsMenuItems()}
                            </TextField>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Shares, %</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="sharesInPercent"
                                label="Shares, %"
                                value={companyMember.sharesInPercent ?? ''}
                                onChange={handleFieldChange}
                                fullWidth
                                error={!!errors.sharesInPercent}
                                helperText={errors.sharesInPercent}
                            />
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </Container>
    );
};

export default LimitEditPage;
